import { Animate, AnimateTransform, type Keys } from '../smil';
import { INK, LINE } from './app-impact-style';

/** The base of the neck, so a tilt barely moves the collar where it meets the shoulders. */
const NECK = '585 790';
const EYE_X = [491.58, 563.8];

const open = (x: number) => `M${x} 602.46Q${x} 607 ${x} 611.56`;
const shut = (x: number) => `M${x - 5} 608Q${x} 610.5 ${x + 5} 608`;
const happy = (x: number) => `M${x - 6} 609Q${x} 597 ${x + 6} 609`;

/** Blink, focus on the phone, squint on the tap, beam while the coins fly, blink again. */
function eyeKeys(x: number): Keys {
	return [
		[0.8, open(x)],
		[0.87, shut(x)],
		[0.95, open(x)],
		[1.56, open(x)],
		[1.62, shut(x), 'out'],
		[1.76, open(x)],
		[1.86, open(x)],
		[1.98, happy(x), 'out'],
		[3.65, happy(x)],
		[3.85, open(x)],
		[5.1, open(x)],
		[5.17, shut(x)],
		[5.26, open(x)],
	];
}

const SMILE = 'M524.65 674.802C524.65 674.802 552.65 689.082 563.8 656.172';
const SMILE_FOCUSED = 'M528 676C528 676 548 683 558 666';
const GRIN = 'M520 667C526 697 564 694 568 652C553 667 537 672 520 667Z';

export function Face() {
	return (
		<g>
			<AnimateTransform
				type="rotate"
				keys={[
					[1, `0 ${NECK}`],
					[1.35, `-1.8 ${NECK}`],
					[1.85, `-1.8 ${NECK}`],
					[2.15, `2.6 ${NECK}`, 'out'],
					[2.4, `1.6 ${NECK}`],
					[3.7, `1.6 ${NECK}`],
					[4.2, `0 ${NECK}`],
				]}
			/>
			<path
				d="M524.6 650.931C524.6 650.931 495.78 650.201 498.72 636.001C501.66 621.811 522.04 623.871 522.04 623.871L525.56 592.551"
				{...LINE}
			/>
			<path d={SMILE} {...LINE}>
				<Animate
					attr="d"
					keys={[
						[1, SMILE],
						[1.3, SMILE_FOCUSED],
						[1.85, SMILE_FOCUSED],
						[1.95, SMILE],
					]}
				/>
				<Animate
					attr="opacity"
					keys={[
						[1.9, 1],
						[1.96, 0],
						[3.7, 0],
						[3.8, 1],
					]}
				/>
			</path>
			<path d={GRIN} {...LINE} fill={INK} opacity={0}>
				<Animate
					attr="opacity"
					keys={[
						[1.9, 0],
						[1.96, 1],
						[3.7, 1],
						[3.8, 0],
					]}
				/>
			</path>
			<g>
				<AnimateTransform
					type="translate"
					keys={[
						[1, '0 0'],
						[1.3, '-4 4'],
						[1.8, '-4 4'],
						[2.05, '-4 -5'],
						[3.6, '-4 -5'],
						[4, '0 0'],
					]}
				/>
				{EYE_X.map((x) => (
					<path key={x} d={open(x)} {...LINE}>
						<Animate attr="d" keys={eyeKeys(x)} />
					</path>
				))}
			</g>
			<path d="M571.26 720.74C571.26 720.74 422.24 800.38 459.77 574" {...LINE} />
			<path
				d="M447.27 573.989C447.27 573.989 529.98 579.529 571.26 503.809C571.26 503.809 551.74 573.649 631.56 577.179L638.02 616.109C638.02 616.109 686.74 579.279 697.3 621.079C707.86 662.869 663.84 670.609 640.95 656.169L637.43 770.769C637.43 770.769 579.91 820.159 534.72 790.819L525.57 734.319"
				{...LINE}
			/>
			<path d="M657.76 628.541L674.65 623.871" {...LINE} />
			<path d="M667.07 682.198V647.238" {...LINE}>
				<AnimateTransform
					type="rotate"
					keys={[
						[1.62, '0 667 647'],
						[1.72, '6 667 647'],
						[1.86, '0 667 647'],
						[2.2, '14 667 647', 'out'],
						[2.45, '-9 667 647'],
						[2.7, '5 667 647'],
						[2.95, '-2 667 647'],
						[3.15, '0 667 647'],
					]}
				/>
			</path>
			<path
				d="M464.781 700.679C464.781 700.679 418.431 715.139 392.781 675.899C373.421 646.289 375.741 607.179 398.241 579.879C406.481 569.879 418.091 560.159 434.431 552.509C434.431 552.509 425.791 438.829 545.611 422.949C545.611 422.949 651.441 410.379 663.051 517.129C663.051 517.129 715.171 501.299 738.791 552.889C762.411 604.479 735.481 636.649 735.481 636.649C735.481 636.649 784.481 625.609 814.961 667.169C845.441 708.729 840.031 746.279 840.031 746.279C840.031 746.279 876.741 770.789 866.301 809.539C862.881 822.219 845.901 840.269 816.521 844.109"
				{...LINE}
			/>
		</g>
	);
}
